import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { getStatusesByBundleGuid } from './getStatusesByBundleGuid';

export const getBundleIsFinishedAssemblyOrLater = createSelector(
  getStatusesByBundleGuid,

  (statusesByBundleGuid) =>
    mapValues(statusesByBundleGuid, (statuses) =>
      statuses.every(
        (status) =>
          status === 'FinishedAssembly' || status === 'StoredOnYard' || status === 'Shipped' || status === 'Delivered',
      ),
    ),
);
